import { InjectionToken, ElementRef } from '@angular/core';

export type ToastSeverity = 'danger' | 'warning' | 'success' | 'info';

export const TOAST_DATA = new InjectionToken<ToastData>('TOAST_DATA');

export interface ToastData {
  origin?: ElementRef;
  message: string;
  severity: ToastSeverity;
}
